import CouponMarketplaceCouponInfo from './coupon-marketplace-coupon-info-view'

export default CouponMarketplaceCouponInfo
